// Sustemia · Balance Hídrico · catálogo de tipologías
// Portado de casos-de-campo-v1.js (CASOS_DE_CAMPO_v1) + estructura de
// procesos de Sustemia_BalanceHidrico_Modulo_ES_v1_2026-08-11.html (TIPOS_FABRICA).
//
// DATOS PUROS. Sin lógica de cálculo. La tipología precarga la biblioteca de
// centros y el set de casos de campo, en vez de mostrar la biblioteca
// completa a todos (ver Guía de campo §2).

export const TIPOLOGIAS = {
  A_TELAS: {
    id: "A_TELAS",
    nombre: "Fábrica de telas",
    descripcion: "Proceso húmedo intensivo, continuo: tintorería, acabado, servicios auxiliares (caldera, torre), ETP",
    centrosPrecargados: [
      { id: "pozo", nombre: "Pozo propio", recibe: "—", descarga: "Red interna", fluido: "limpia", instrumentoSugerido: "turbina" },
      { id: "red_municipal", nombre: "Red municipal", recibe: "—", descarga: "Red interna", fluido: "limpia", instrumentoSugerido: "factura" },
      { id: "tintoreria", nombre: "Tintorería y acabado", recibe: "Colector de agua tratada", descarga: "Planta de tratamiento", fluido: "proceso", instrumentoSugerido: "turbina" },
      { id: "acabado", nombre: "Rame y secado", recibe: "—", descarga: "Evaporación al aire", fluido: "proceso", instrumentoSugerido: "ficha" },
      { id: "caldera", nombre: "Caldera", recibe: "Ósmosis inversa", descarga: "Vapor y purga", fluido: "vapor", instrumentoSugerido: "condensado" },
      { id: "torre_enfriamiento", nombre: "Torre de enfriamiento", recibe: "Colector general", descarga: "Evaporación al aire", fluido: "limpia", instrumentoSugerido: "turbina" },
      { id: "osmosis", nombre: "Ósmosis inversa", recibe: "Colector general", descarga: "Caldera + rechazo", fluido: "limpia", instrumentoSugerido: "turbina" },
      { id: "etp", nombre: "Planta de tratamiento (ETP)", recibe: "Todos los efluentes", descarga: "Colectora o cuerpo receptor", fluido: "efluente", instrumentoSugerido: "electro" },
      { id: "sanitarios", nombre: "Sanitarios y comedor", recibe: "Colector general", descarga: "Planta de tratamiento", fluido: "proceso", instrumentoSugerido: "ficha" },
    ],
    benchmark: {
      disponible: true,
      fuenteId: "IFC_EHS_TEXTIL",
      localizador: "tabla 4",
      advertenciasObligatorias: [
        "Proviene de la Comisión Europea 2003 y se basa en un número limitado de instalaciones.",
        "El registro remite al BREF TXT 2023 del JRC, que reemplazó esa versión.",
      ],
    },
    casos: ["A1_POZO_MACROMEDIDOR", "A2_TORRE_POR_DIFERENCIA", "A3_CALDERA_POR_DIFERENCIA"],
  },

  B_ETIQUETAS: {
    id: "B_ETIQUETAS",
    nombre: "Fábrica de etiquetas",
    descripcion: "Proceso húmedo acotado, mucha mano de obra: tintura de cintas por lotes chicos, limpieza, sanitarios con peso relativo alto",
    centrosPrecargados: [
      { id: "red_municipal", nombre: "Red municipal", recibe: "—", descarga: "Acometida única", fluido: "limpia", instrumentoSugerido: "compartido" },
      { id: "tintura_cintas", nombre: "Tintura de cintas", recibe: "Acometida única", descarga: "Colectora", fluido: "proceso", instrumentoSugerido: "ficha" },
      { id: "limpieza", nombre: "Lavado de mallas y racletas", recibe: "Acometida única", descarga: "Colectora", fluido: "limpia", instrumentoSugerido: "aforo" },
      { id: "sanitarios", nombre: "Sanitarios", recibe: "Acometida única", descarga: "Colectora", fluido: "proceso", instrumentoSugerido: "ficha" },
      { id: "comedor", nombre: "Comedor", recibe: "Acometida única", descarga: "Colectora", fluido: "proceso", instrumentoSugerido: "ficha" },
      { id: "cisterna", nombre: "Cisterna", recibe: "Acometida única", descarga: "Red interna", fluido: "limpia", instrumentoSugerido: "nivel" },
    ],
    benchmark: {
      disponible: false,
      motivo: "Sin fuente publicada verificada para tejido angosto ni etiquetas impresas.",
      evaluarEnSuLugar: ["tendencia_vs_linea_base", "indice_calidad_dato"],
    },
    casos: ["B1_MEDIDOR_COMPARTIDO", "B2_VARIACION_INVENTARIO"],
  },

  C_PRODUCTO_TERMINADO: {
    id: "C_PRODUCTO_TERMINADO",
    nombre: "Fábrica de producto terminado",
    descripcion: "Corte y confección en seco + lavandería. Si no hay lavandería, el balance es casi todo doméstico",
    centrosPrecargados: [
      { id: "red_municipal", nombre: "Red municipal", recibe: "—", descarga: "Colector general", fluido: "limpia", instrumentoSugerido: "factura" },
      { id: "lavanderia", nombre: "Lavandería industrial", recibe: "Colector general", descarga: "Colectora", fluido: "proceso", instrumentoSugerido: "turbina" },
      { id: "sanitarios", nombre: "Sanitarios", recibe: "Colector general", descarga: "Colectora", fluido: "proceso", instrumentoSugerido: "ficha" },
      { id: "comedor", nombre: "Comedor", recibe: "Colector general", descarga: "Colectora", fluido: "proceso", instrumentoSugerido: "ficha" },
      { id: "riego", nombre: "Riego de espacios verdes", recibe: "Colector general", descarga: "Al suelo", fluido: "proceso", instrumentoSugerido: "ficha" },
      { id: "cisterna", nombre: "Cisterna", recibe: "Colector general", descarga: "Red interna", fluido: "limpia", instrumentoSugerido: "nivel" },
    ],
    // Si la empresa declara que no hay lavandería, el centro se OCULTA, no se
    // muestra en cero (ver Guía de campo §2: "un formulario con veinte campos
    // en cero es la forma más rápida de que alguien empiece a rellenar con
    // supuestos").
    centrosCondicionales: { lavanderia: "hasLaundry" },
    benchmark: {
      disponible: false,
      motivo: "Sin fuente publicada verificada por prenda ni por kg para confección ni lavandería de prenda terminada.",
      evaluarEnSuLugar: ["tendencia_vs_linea_base", "indice_calidad_dato"],
    },
    casos: ["C1_LAVANDERIA_RELACION_BANO", "C2_CIERRE_FACTURA_Y_TANQUE"],
  },

  // Portadas del prototipo (TIPOS_FABRICA.hilanderia/cero en
  // Sustemia_BalanceHidrico_Modulo_ES_v1_2026-08-11.html), que la hoja
  // "CATÁLOGOS" del spec confirma como parte de la lista cerrada de
  // tipologías. Ninguna de las dos tiene fichas de campo propias en la
  // Guía de campo: no se inventan casos que la fuente no define.
  D_HILANDERIA: {
    id: "D_HILANDERIA",
    nombre: "Hilandería",
    descripcion: "Poco proceso húmedo, mucho acondicionamiento de aire: humidificación de sala y torre de enfriamiento",
    centrosPrecargados: [
      { id: "red_municipal", nombre: "Red municipal", recibe: "—", descarga: "Colector general", fluido: "limpia", instrumentoSugerido: "factura" },
      { id: "humidificacion", nombre: "Humidificación de sala", recibe: "Colector general", descarga: "Evaporación al aire", fluido: "limpia", instrumentoSugerido: "turbina" },
      { id: "torre_enfriamiento", nombre: "Torre de enfriamiento", recibe: "Colector general", descarga: "Evaporación al aire", fluido: "limpia", instrumentoSugerido: "turbina" },
      { id: "sanitarios", nombre: "Sanitarios y comedor", recibe: "Colector general", descarga: "Colectora", fluido: "proceso", instrumentoSugerido: "ficha" },
    ],
    benchmark: {
      disponible: false,
      motivo: "Sin fuente publicada verificada para consumo específico de hilandería.",
      evaluarEnSuLugar: ["tendencia_vs_linea_base", "indice_calidad_dato"],
    },
    casos: [],
  },

  E_CERO: {
    id: "E_CERO",
    nombre: "Empezar de cero",
    descripcion: "Ningún proceso precargado: los centros de cantidad se declaran a mano en el paso siguiente.",
    centrosPrecargados: [],
    benchmark: {
      disponible: false,
      motivo: "Sin tipología declarada, no hay benchmark publicado que aplicar.",
      evaluarEnSuLugar: ["tendencia_vs_linea_base", "indice_calidad_dato"],
    },
    casos: [],
  },

  // Agregada a pedido del cliente (consulta B·01): una planta que no encaja
  // en ninguna tipología textil específica, sin forzarla a elegir una de las
  // anteriores "por aproximación". Se distingue de "Empezar de cero" en el
  // propósito: esta es para una planta real que simplemente no es textil,
  // no para alguien que todavía no decidió su estructura.
  F_FABRICA: {
    id: "F_FABRICA",
    nombre: "Fábrica",
    descripcion: "Planta que no encaja en ninguna de las tipologías textiles anteriores (telas, etiquetas, producto terminado, hilandería). Sin centros precargados: cada centro se declara a mano.",
    centrosPrecargados: [],
    benchmark: {
      disponible: false,
      motivo: "Sin comparación: las referencias publicadas de este módulo son específicas del sector textil y no aplican a una planta sin tipología definida.",
      evaluarEnSuLugar: ["tendencia_vs_linea_base", "indice_calidad_dato"],
    },
    casos: [],
  },
};

export function centrosDeTipologia(tipologiaId, { hasLaundry = true } = {}) {
  const t = TIPOLOGIAS[tipologiaId];
  if (!t) return [];
  const condicionales = t.centrosCondicionales || {};
  return t.centrosPrecargados.filter((c) => {
    const condicion = condicionales[c.id];
    if (condicion === "hasLaundry") return hasLaundry;
    return true;
  });
}

export default { TIPOLOGIAS, centrosDeTipologia };
